import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { savePaymentMethod } from '../slices/cartSlice.js'

function PaymentScreen() {

    const [paymentMethod] = useState('Stripe')

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const cart = useSelector((state) => state.cart)
    const { shippingAddress } = cart

    useEffect(() => {
        if (!shippingAddress) {
            navigate('/shipping')
        }
     }, [shippingAddress, navigate])

     function submitHandler(e) {
        e.preventDefault()
        dispatch(savePaymentMethod(paymentMethod))
        navigate('/placeorder')
     }

  return (
    <section className='mx-auto w-full max-w-2xl'>
      <div className='rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8'>
        <p className='mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-sky-700'>
          Checkout
        </p>
        <h1 className='mb-6 text-3xl font-semibold text-slate-900'>Payment Method</h1>

        <form onSubmit={submitHandler} className='space-y-5'>
          <fieldset>
            <legend className='mb-2 text-sm font-medium text-slate-700'>Selected Method</legend>
            <label className='flex cursor-default items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3'>
              <input
                type='radio'
                id='Stripe'
                name='paymentMethod'
                value='Stripe'
                checked
                onChange={() => {}}
                className='h-4 w-4 accent-sky-600'
              />
              <span className='text-sm font-semibold text-slate-800'>Stripe (Card)</span>
            </label>
          </fieldset>

          <button
            type='submit'
            className='inline-flex items-center justify-center rounded-xl bg-sky-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-sky-700'
          >
            Continue
          </button>
        </form>
      </div>
    </section>
  )
}

export default PaymentScreen
